import React from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";

const PageHeader = ({ title, onGoBack, actions = null, showBackButton = true }) => {
  return (
    <div className="flex items-center justify-between mb-8">
      {showBackButton && (
        <button className="mr-3 text-black px-4 py-2 rounded flex items-center" onClick={onGoBack}>
          <AiOutlineArrowLeft className="text-lg font-bold text-xl" />
        </button>
      )}

      <h1 className="text-2xl font-bold">{title}</h1>

      <div style={{ marginLeft: "auto" }}>{actions || <div></div>}</div>
    </div>
  );
};

export default PageHeader;
